<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="form-group font-weight-bold input-info">
    <label class="field-title mb-2 font-weight-bold" for="username">Email Address</label>
    <input
      type="text"
      formControlName="username"
      placeholder="Insert email here"
      class="form-control border-0 bg-muted pl-2 mb-1"
      [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
    />
    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
      <div class="alert-danger" *ngIf="f.username.errors.required">This field is required</div>
    </div>
  </div>

  <div class="form-group input-info font-weight-bold">
    <label class="field-title password-field mb-2 mt-0 mt-lg-0 font-weight-bold" for="password">Password</label>
    <input
      type="password"
      formControlName="password"
      placeholder="Insert password here"
      class="form-control border-0 bg-muted pl-2 mb-1"
      [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
    />

    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
      <div class="alert-danger" *ngIf="f.password.errors.required">This field is required</div>
    </div>
  </div>

  <div class="form-group mb-2 mt-4 mt-lg-0">
    <button
      [disabled]="loading"
      class="btn btn-success btn-block login-button font-size-14 w-100 font-weight-bold"
      aria-label="Login"
    >
      <span *ngIf="!loading">Login</span>
      <fgbcl-loading [size]="'small'" *ngIf="loading"></fgbcl-loading>
    </button>
  </div>
  <div class="panel-text forgot-password text-center font-size-12">
    <a class="font-weight-bold text-danger" href="https://www.mlb.com/forgot-password" target="_blank">Forgot Password?</a>
  </div>
</form>
